import { useEffect, useMemo, useState } from 'react'
import './user-list-container.styles.scss'
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { getAllUsersFromDb } from '@/utils/getAdminData';
import { listenToCollection } from '@/utils/getDataFromDb';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import UserAvatar from './user-avatar.component';

// Everyone with a profile, as cards that work on a phone. Search by name or
// email; each card shows how many leagues the user manages a team in.
const UserListContainer = () => {

    const [ users, setUsers ] = useState(null);
    const [ leagues, setLeagues ] = useState(null);
    const [ search, setSearch ] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        let userListener;
        let leagueListener;
        let found = {};
        getAllUsersFromDb({
            'callback': (u) => { found = { ...found, [u.appId]: u }; setUsers(found); },
            'receiveListener': (unsub) => { userListener = unsub; },
        });
        listenToCollection({
            'path': 'leagues',
            'callback': setLeagues,
            'handleListener': (unsub) => { leagueListener = unsub; },
        });
        return () => {
            if (userListener) userListener();
            if (leagueListener) leagueListener();
        }
    }, [])

    // appId -> number of leagues they manage a team in.
    const leagueCount = useMemo(() => {
        const counts = {};
        for (const l of Object.values(leagues ?? {})) {
            for (const appId of Object.keys(l.managers ?? {})) counts[appId] = (counts[appId] ?? 0) + 1;
        }
        return counts;
    }, [leagues]);

    const term = search.trim().toLowerCase();
    const list = users && Object.values(users)
        .filter(u => !term || (u.name ?? '').toLowerCase().includes(term) || (u.email ?? '').toLowerCase().includes(term))
        .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' }));

    return (
        <div className='user-list'>
            <div className='section-title'>
                <span>Users</span>
                {users && <span className='meta'>{Object.keys(users).length} total</span>}
            </div>
            <label className='user-search'>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
                <input
                    type='search'
                    placeholder='Search by name or email'
                    aria-label='Search users'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)} />
            </label>
            {!list && <div className='center-col'><ThreeDotsLoader /></div>}
            {list && list.length === 0 && <div className='g-card'><p className='meta'>No users match “{search}”.</p></div>}
            <div className='user-cards'>
                {list && list.map(u => {
                    const n = leagueCount[u.appId] ?? 0;
                    return (
                        <button key={u.appId} className='g-card user-card' onClick={() => navigate(`/admin/users/${u.appId}`)}>
                            <UserAvatar user={u} />
                            <div className='user-card-main'>
                                <div className='user-name'>{u.name || 'No name yet'}</div>
                                <div className='user-email'>{u.email}</div>
                                <div className='meta'>
                                    {n === 0 ? 'No teams' : `${n} league${n === 1 ? '' : 's'}`}
                                    {u.created > 86400000 ? ` · Joined ${format(new Date(u.created), 'PP')}` : ''}
                                </div>
                            </div>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default UserListContainer
